import { PropsWithChildren } from 'react';
import './QuestionCard.scss';
import { CopyButton } from '../../Components/CopyButton';

export interface QuestionCardProps extends PropsWithChildren {
  questionNumber: string;
  url?: string;
  className?: string;
  hide?: boolean;
}

export const QuestionCard = ({
  questionNumber,
  children,
  url = window.location.href.split('#')[0],
  className,
  hide = false
}: QuestionCardProps) => (
  <div id={questionNumber} className={`question-card ${className || ''} ${hide ? 'hide' : ''}`}>
    <div className='question-header'>
      <div className='question-number'>{questionNumber}</div>
      <CopyButton
        id={`${questionNumber}-copyButton`}
        text={`${url}#${questionNumber}`}
        tooltipLabel='Copy link'
      />
    </div>
    <div className='question-card-content'>{children}</div>
  </div>
);
